import axios from "axios";
import { jwtDecode } from "jwt-decode";

export const getCurrentClientData = () => {
  let clientData;
  let token;
  let tokenDuration;
  let eventAuthAt;
  let token_id;
  let customer_id;
  let username;
  let brand_name;
  let first_name;
  let full_name;
  let mfa_reminder;
  let role;
  let status;
  let type;
  let account_type;
  let payout;

  const authToken = localStorage.getItem("streamEventAuthToken");

  try {
    if (authToken) {
      const parsedAuthToken = JSON.parse(authToken);
      clientData = parsedAuthToken?.uData;
      token = parsedAuthToken?.streamEventAcToken;
      tokenDuration = parsedAuthToken.eventTokenDuration;
      eventAuthAt = parsedAuthToken.eventAuthAt;
      token_id = parsedAuthToken?.streamEventIdToken;
      account_type = parsedAuthToken?.account_type;
      payout = parsedAuthToken?.payout;

      if (clientData) {
        customer_id = clientData["cognito:customer_id"] || clientData.sub;
        username = clientData["cognito:username"];
        brand_name =
          clientData["custom:brand_name"] || clientData["custom:company_name"];
        first_name = clientData.given_name;
        full_name = clientData.full_name;
        mfa_reminder = clientData["custom:mfa_reminder"];
        role = clientData["custom:role"];
        status = clientData["custom:status"];
        type = clientData["custom:type"];
      }
    }
  } catch (error) {
    // Handle the JSON parsing error
    console.error("Error parsing JSON:", error);
  }

  return {
    clientData,
    token,
    tokenDuration,
    eventAuthAt,
    token_id,
    brand_name,
    customer_id,
    username,
    first_name,
    full_name,
    mfa_reminder,
    role,
    status,
    type,
    account_type,
    payout,
  };
};

export const saveUserTokenSession = async (res: any) => {
  try {
    const streamEventAcToken = res.body.data.access_token;
    const streamEventIdToken = res.body.data.id_token;
    const streamEventRefToken = res.body.data.refresh_token;
    const streamEventTokenDuration = res.body.data.expiresIn;
    const streamEventAuthAt = Math.floor(Date.now() / 1000);
    const streamEventAuth = {
      streamEventAcToken,
      streamEventIdToken,
      streamEventRefToken,
      streamEventTokenDuration,
      streamEventAuthAt,
      uData: decodeJwt(streamEventIdToken),
      account_type: res.body.data.account_type,
      payout: res.body.data.payout,
    };

    sessionStorage.setItem(
      "streamEventAuthToken",
      JSON.stringify(streamEventAuth)
    );
    localStorage.setItem(
      "streamEventAuthToken",
      JSON.stringify(streamEventAuth)
    );

    return {
      response: res,
      statusCode: res.statusCode,
      error: res.body?.error,
      success: res.body?.success,
      message: res.body?.message,
      data: { ...streamEventAuth },
    };
  } catch (error) {
    return error;
  }
};

export const decodeJwt = (jwt: string) => {
  return jwtDecode(jwt);
};

// SETTINGS API
export const getUserSettings = async (token: string) => {
  try {
    return await axios.get(
      `${import.meta.env.VITE_API_BASE_URL}/core/v1/user-settings`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (error) {
    return error;
  }
};

export const updateSettings = async (settings: any) => {
  try {
    const response = await axios.put(
      `${import.meta.env.VITE_API_BASE_URL}/settings`,
      settings
    );
    return response.data;
  } catch (error) {
    console.error("Error updating settings:", error);
    throw error;
  }
};
export const refreshTokenApi = async (data: any) => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_API_BASE_URL}/open/v1/refresh-token`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating settings:", error);
    throw error;
  }
};

export const updateLocalStorageField = (updatedFields: Partial<any>) => {
  const authToken = localStorage.getItem("streamEventAuthToken");

  if (!authToken) return;

  try {
    const parsed = JSON.parse(authToken);

    const updated = {
      ...parsed,
      ...updatedFields, // merge new fields (top-level only)
    };

    // Update localStorage and sessionStorage
    localStorage.setItem("streamEventAuthToken", JSON.stringify(updated));
    sessionStorage.setItem("streamEventAuthToken", JSON.stringify(updated));
  } catch (error) {
    console.error("Failed to update local storage token:", error);
  }
};
